"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.daysBetween = daysBetween;
exports.formatDateShort = formatDateShort;
exports.formatDateRange = formatDateRange;
/** Calculate inclusive day count between two YYYY-MM-DD strings. */
function daysBetween(startISO, endISO) {
    const start = new Date(startISO);
    const end = new Date(endISO);
    const diffMs = end.getTime() - start.getTime();
    const days = Math.round(diffMs / 86_400_000) + 1;
    return Math.max(1, days);
}
/** Format YYYY-MM-DD as "26 Apr 2026" */
function formatDateShort(iso) {
    if (!iso)
        return '';
    const d = new Date(iso);
    return d.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
}
/** Format two dates as a range. */
function formatDateRange(startISO, endISO) {
    if (!startISO)
        return '';
    if (!endISO || startISO === endISO)
        return formatDateShort(startISO);
    const start = new Date(startISO);
    const end = new Date(endISO);
    const sameYear = start.getFullYear() === end.getFullYear();
    const sameMonth = sameYear && start.getMonth() === end.getMonth();
    if (sameMonth) {
        return start.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' }) + ' — ' + end.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
    }
    return formatDateShort(startISO) + ' — ' + formatDateShort(endISO);
}
//# sourceMappingURL=date.js.map